module.exports = __webpack_public_path__ + "static/media/our-coaches-2.29e8b29e.jpg";